
import {
  WP_JSON_API_REQUEST,
  WP_JSON_API_ERROR,
  WP_JSON_API_SUCCESS,
  SELECT_TRIP_OR_TRAILHEAD,
  DESELECT_TRIP_OR_TRAILHEAD,
} from '../common/actionTypes';

export const defaultTripsTrailheadsState = {
  trailheads: undefined,
  trips: undefined,
  fetchingData: false,
  error: undefined,
};

// handles storing data for trips and trailheads from the Wordpress JSON API
export default (state = defaultTripsTrailheadsState, action) => {
  switch (action.type) {
    case WP_JSON_API_REQUEST:
      return {
        ...state,
        fetchingData: true,
      };

    case WP_JSON_API_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        trips: action.category === 'trips' ? action.json : state.trips,
        trailheads: action.category === 'trailheads' ? action.json : state.trailheads
      };

    case WP_JSON_API_ERROR:
      return {
        ...state,
        fetchingData: false,
        error: action.error,
      };

    case SELECT_TRIP_OR_TRAILHEAD:
      return {
        ...state,
        selected: action.id,
        selector: action.selector,
      };

    case DESELECT_TRIP_OR_TRAILHEAD:
      return {
        ...state,
        selected: undefined,
        selector: undefined,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./map/reducers/tripsTrailheadsReducer.js